/**
 * Promise pages (100 nights · Warranty · Payments & delivery): three small tools.
 * All words and numbers come from the page (section settings and store records);
 * nothing is typed here.
 *   <sunday-info-years>  tap a year: % of what you paid, and its value on the example mattress
 *   <sunday-info-emi>    mattress × size × months → the monthly amount at 0%, the mattress's full
 *                        name and size, and a link to that mattress in that size
 *   (the pincode field is the site's one <sunday-delivery>, mode "zones")
 */
import { money as rupees, emi, fill } from '@sunday/util';

class SundayInfoYears extends HTMLElement {
  connectedCallback() {
    this.price = Number(this.dataset.price) || 0;
    this.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-y]');
      if (b) this.pick(b);
    });
    this.pick(this.querySelector(`button[data-y="${this.dataset.start}"]`) || this.querySelector('button[data-y]'));
  }

  pick(b) {
    if (!b) return;
    for (const x of this.querySelectorAll('button[data-y]')) x.setAttribute('aria-pressed', String(x === b));
    const pct = Number(b.dataset.pct);
    this.querySelector('[data-pct-out]').textContent = `${pct}%`;
    const first = b.dataset.y === '1';
    this.querySelector('[data-first]').hidden = !first;
    this.querySelector('[data-later]').hidden = first;
    const v = this.querySelector('[data-value-out]');
    if (v) v.textContent = rupees(Math.round((this.price * pct) / 100));
  }
}

class SundayInfoEmi extends HTMLElement {
  connectedCallback() {
    this.cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-p], button[data-w], button[data-m]');
      if (!b) return;
      const attr = ['p', 'w', 'm'].find((k) => k in b.dataset);
      for (const x of b.parentElement.querySelectorAll(`button[data-${attr}]`)) x.setAttribute('aria-pressed', String(x === b));
      this.show();
    });
    this.show();
  }

  on(attr) {
    const b = this.querySelector(`button[data-${attr}][aria-pressed="true"]`) || this.querySelector(`button[data-${attr}]`);
    return b ? b.dataset[attr] : null;
  }

  show() {
    const m = this.cfg.mattresses.find((x) => x.id === this.on('p')) || this.cfg.mattresses[0];
    const pb = this.querySelector('button[data-p][aria-pressed="true"]');
    if (pb) this.style.setProperty('--sd-mc', pb.style.getPropertyValue('--c'));
    // one month option: no chip, the months are in the result line
    const only = this.cfg.months && this.cfg.months.length ? this.cfg.months[this.cfg.months.length - 1] : 1;
    const months = Number(this.on('m')) || only;
    const w = this.on('w');
    const total = (m && m.prices[w]) || 0;
    const out = this.querySelector('[data-out]');
    const who = this.querySelector('[data-who]');
    const pre = this.querySelector('[data-pre]');
    const go = this.querySelector('[data-go]');
    if (!total) {
      out.textContent = '';
      this.querySelector('[data-per]').textContent = '';
      this.querySelector('[data-sub]').textContent = '';
      if (who) who.textContent = '';
      if (pre) pre.textContent = '';
      if (go) go.hidden = true;
      return;
    }
    const sb = this.querySelector('button[data-w][aria-pressed="true"]');
    const size = sb ? sb.textContent.trim() : '';
    if (who) who.textContent = size ? `${m.name} · ${size}` : m.name;
    if (pre) pre.textContent = this.cfg.pre || '';
    out.textContent = rupees(emi(total, months));
    this.querySelector('[data-per]').textContent = this.cfg.per;
    this.querySelector('[data-sub]').textContent = fill(this.cfg.sub, { months, total: rupees(total) });
    if (go && m.url) {
      const vid = m.variants && m.variants[w];
      go.href = vid ? `${m.url}?variant=${vid}` : m.url;
      go.textContent = fill(this.cfg.go, { name: m.name });
      go.hidden = false;
    }
  }
}

if (!customElements.get('sunday-info-years')) customElements.define('sunday-info-years', SundayInfoYears);
if (!customElements.get('sunday-info-emi')) customElements.define('sunday-info-emi', SundayInfoEmi);